import React from "react";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { ResizableTable } from "../../../components/resizableTable/ResizableTable";

const ForecastMovedOutPaper = ({
  classes,
  paperTitle,
  isForecastMovedOutLoading,
  forecastMovedOutData,
  forecastMovedOutColumns, // Pass columns from parent
  forecastMovedOutRows, // Pass rows from parent
  getCellValue, // Function to get cell value for the table
  getCellStyle, // Function to get cell style for the table
  handleChangeLocation, // Function to handle row click for drilldown
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
          <Typography variant="h6" className={classes.title}>
            Sales Forecast – Current Quarter – Forecast – Most Likely + Commit
            Opps moved out in the last week
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>
        {isForecastMovedOutLoading ? (
          <Skeleton variant="rect" animation="wave" height={200} width="100%" />
        ) : (
          <>
            {!forecastMovedOutData?.movedOutOpps ||
            forecastMovedOutData.movedOutOpps.length === 0 ? (
              <Box
                textAlign="center"
                py={4}
                style={{ fontStyle: "italic", color: "#666" }}
              >
                No forecast opps moved out this week
              </Box>
            ) : (
              <ResizableTable
                columns={forecastMovedOutColumns}
                rows={forecastMovedOutRows}
                getCellValue={getCellValue}
                getCellStyle={getCellStyle}
                rowKey="label"
                hideSubHeaderRow={true}
                maxWidth="100%"
                onRowClick={(row) =>
                  handleChangeLocation("drilldownOnGraph", row, "movedOut")
                }
              />
            )}
          </>
        )}
      </Paper>
    </Grid>
  );
};

export default ForecastMovedOutPaper;
